/**
 * @description Component-EnableAgentModal
 */
import { GlobalModalType } from '@/constants';
import './index.less';

import { Button } from '@/components/Button';
import Modal from '@/components/Modal';
import { useModalOpen, useToggleModal } from '@/features/global/hooks';
import classNames from 'classnames';
import { FC } from 'react';
import { useAgentAction, useIsEnableAgent } from '../hook';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
}
const EnableAgentModal: FC<IPropTypes> = function ({ className }) {
  const isShowEnableAgentModal = useModalOpen(GlobalModalType.ENABLE_AGENT);

  const toggleEnableAgentModal = useToggleModal(GlobalModalType.ENABLE_AGENT);
  const isEnableAgent = useIsEnableAgent();
  const { tryEnableAgent, isTradingModeChanging } = useAgentAction();

  if (isEnableAgent) {
    return null;
  }

  return (
    <Modal
      title={'Enable Trading'}
      centered
      width={440}
      closable={!isTradingModeChanging}
      open={isShowEnableAgentModal}
      onCancel={() => toggleEnableAgentModal(false)}
      className={classNames('syn-enable-agent-modal', className)}>
      <div className="syn-enable-agent-modal-wrap">
        <div className="syn-enable-agent-modal-wrap-content">
          This signature is gas-free to send. Enable gas-free transaction and instantaneous trading.
        </div>
        <Button loading={isTradingModeChanging} type="primary" block onClick={() => tryEnableAgent()}>
          Enable Trading
        </Button>
      </div>
    </Modal>
  );
};

export default EnableAgentModal;
